export const letterOrders = {
  abc: [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ],
  qwerty: [
    'q',
    'w',
    'e',
    'r',
    't',
    'y',
    'u',
    'i',
    'o',
    'p',
    'a',
    's',
    'd',
    'f',
    'g',
    'h',
    'j',
    'k',
    'l',
    'z',
    'x',
    'c',
    'v',
    'b',
    'n',
    'm',
  ],
};

export const numpad = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['Layout:abc', '0', 'Backspace'],
];

export const numpadOnly = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['Finished', '0', 'Backspace'],
];

export const symbolList = [
  '@',
  '#',
  '%',
  '$',
  '_',
  '&',
  '-',
  '+',
  '(',
  ')',
  '/',
  '*',
  '"',
  "'",
  ':',
  '!',
  '?',
  '`',
  '^',
  '[',
  ']',
  '<',
  '>',
  '=',
  '{',
  '}',
  '.',
  'Layout:abc',
  'Backspace',
];

export const emailSymbolList = [
  '!',
  '#',
  '$',
  '%',
  '&',
  "'",
  '*',
  '+',
  '-',
  '/',
  '=',
  '?',
  '^',
  '_',
  '`',
  '{',
  '|',
  '}',
  '~',
  'Layout:abc',
  'Backspace',
];
